<template>
  <div :class="['inner-search', active ? 'focused' : '']">
    <input
      ref="searchfield"
      :value="searchString"
      @input="$emit('update:searchString', $event.target.value)"
      type="text"
      :placeholder="localize('Search')"
      @focus="searchFocus"
      @blur="searchBlur"
    />
    <i
      @click="clearSearchString"
      :class="['mr-xs', 'fal', searchString ? 'fa-times' : 'fa-search']"
    ></i>
  </div>
</template>

<script>
export default {
  props: {
    searchString: String
  },
  data() {
    return {
      active: false
    };
  },
  methods: {
    searchFocus() {
      this.active = true;
    },
    searchBlur() {
      if (!this.searchString) {
        this.active = false;
        this.$emit("search-by-string", null);
      }
    },
    clearSearchString() {
      if (!this.searchString) {
        this.$refs.searchfield.focus();
      } else {
        this.active = false;
        this.$emit("update:searchString", null);
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.inner-search
  border 1px solid gray_4
  border-radius 40px
  height 60px
  display flex
  align-items center
  padding 0 30px
  margin-bottom 40px
  +below(815px)
    height 50px
  input
    width 95%
    height 54px
    margin-right 5%
    border 0
    background none
    outline none
    font-size responsive 16px 22px
    +below(815px)
      height 44px
  i
    font-size 22px
    color gray_5
    transform-origin center
    opacity 0.8
    transition opacity 0.5s ease-out, transform 0.5s ease-out
    will-change opacity, transform
    backface-visibility hidden
    cursor pointer
    &:hover
      opacity 1
    &.fa-times
      transform rotate(-90deg)
    &.fa-search
      // transition opacity 0.5s ease-out, transform 1s ease-out
      transform rotate(0deg)
</style>
